import { createRoutesFromElements, Navigate, Route } from 'react-router-dom';
import { OauthClose } from './components';
import { HomePage } from './components/HomePage';
import {
  LazyDialInNumbersPage,
  LazyHostControlsPage,
  LazyMeetingOverlays,
} from './components/LazyComponents';
import { AuthReadyGate, HomeLayout, MeetingLayout, ProtectedLayout } from './layouts';

/**
 * NG Meet's route tree as data-router route objects.
 *
 * Built with `createRoutesFromElements` so the route declarations stay JSX
 * (easy to read/diff) while producing the `RouteObject[]` shape that the
 * data-router API (`createBrowserRouter` / `createMemoryRouter`) requires.
 *
 * The host-driven Module Federation mount contract (see `bootstrap.tsx`) needs
 * route *objects* so it can hand them to either a browser router (standalone)
 * or a memory router (hosted inside TeamHub, where the host owns the URL bar).
 */
export const appRoutes = createRoutesFromElements(
  <Route>
    {/* Public standalone page — no auth required (SM-829) */}
    <Route path="/dids" element={<LazyDialInNumbersPage />} />

    <Route element={<AuthReadyGate />}>
      <Route path="/close" element={<OauthClose />} />

      <Route element={<ProtectedLayout />}>
        <Route path="/controls/:meetingId" element={<LazyHostControlsPage />} />
      </Route>

      <Route element={<MeetingLayout />}>
        <Route path="/:meetingId" element={<LazyMeetingOverlays />} />
      </Route>

      <Route element={<HomeLayout />}>
        <Route path="/" element={<HomePage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  </Route>,
);
